import React, { Component } from "react";
import {
  Box,
  Heading,
  Text,
  Avatar,
  Button,
  Link,
  Column,
  Sticky,
  Icon,
  Divider,
  Mask,
  Modal,
  IconButton
} from "gestalt";
import { css } from "glamor";
import Product from "./Components/product";
import Banner from "./Components/banner";
import CategoryFilter from "./Components/category-filter";
import firstThreeMonths from "./data/products0-3months";
import Emoji from "./data/emoji";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import BANNER_PRODUCTS from "./data/banner-products";
import ReactGA from "react-ga";

const bannerLinks1 = BANNER_PRODUCTS[1];
const bannerLinks2 = BANNER_PRODUCTS[2];
const bannerLinks3 = BANNER_PRODUCTS[3];
const bannerLinks4 = BANNER_PRODUCTS[4];
const bannerLinks5 = BANNER_PRODUCTS[5];
const bannerLinks6 = BANNER_PRODUCTS[6];

const url =
  "https://dausign.us2.list-manage.com/subscribe/post?u=aeb0e6637be109325b11d68b2&amp;id=94e51a0648";
const CustomForm = ({ status, message, onValidated }) => {
  let email, name;
  const submit = () =>
    email &&
    name &&
    email.value.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email.value,
      NAME: name.value
    });

  return (
    <div className="subscribe">
      <Box margin={1}>
        <input
          className="_yp _3r _2u _2s _tf _sc _sd _se _ti _45 _ys _5s _5n _yq"
          ref={node => (name = node)}
          type="text"
          placeholder="Your name"
        />
      </Box>
      <Box margin={1} marginBottom={4}>
        <input
          className="_yp _3r _2u _2s _tf _sc _sd _se _ti _45 _ys _5s _5n _yq"
          ref={node => (email = node)}
          type="email"
          placeholder="Your email"
        />
      </Box>
      {status === "sending" && <div style={{ color: "blue" }}>sending...</div>}
      {status === "error" && (
        <div
          style={{ color: "red" }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {status === "success" && (
        <div
          style={{ color: "green" }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      <Button color="red" text="Subscribe Now" size="md" onClick={submit} />
    </div>
  );
};

const styles = {
  container: {
    display: "block",
    maxWidth: "1060px",
    margin: "0 auto",
    padding: "10px"
  }
};
const EmojiClicker = ({ emoji, randomEmoji }) => {
  return (
    <a className="emoji" onClick={randomEmoji}>
      {emoji}
    </a>
  );
};
class App extends Component {
  constructor(props) {
    super(props);
    this.handleToggleSmall = this._handleToggleSmall.bind(this);
    this.randomEmoji = this._randomEmoji.bind(this);
    this.state = {
      sm: false,
      activeCategory: "all",
      emoji: null
    };
  }
  componentDidMount() {
    ReactGA.initialize("UA-124209884-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  componentWillMount() {
    this.randomEmoji();
  }
  _handleCategoryFilterClick(category) {
    this.setState({ activeCategory: category });
  }
  _handleToggleSmall() {
    this.setState(prevState => ({ sm: !prevState.sm }));
  }
  _randomEmoji() {
    const emoji = Emoji[Math.floor(Math.random() * Emoji.length)];
    console.log(emoji);
    this.setState({ emoji });
  }
  render() {
    const { sm, activeCategory } = this.state;
    // const categoryArray = ["all"];
    // firstThreeMonths.map(product => {
    //   product.category.map(category => {
    //     if (categoryArray.indexOf(category) < 0) {
    //       categoryArray.push(category);
    //     }
    //   });
    // });
    return (
      <Box>
        <Box
          color="white"
          shape="rounded"
          paddingX={6}
          lgPaddingX={12}
          paddingY={1}
          display="flex"
          direction="row"
          alignItems="center"
        >
          <Box>
            <img
              className="logo"
              src="./assets/images/shopmymom-full-logo.png"
              alt=""
            />{" "}
            <Box paddingX={2}>
              <Text size="xs" accessibilityLevel={3} color="gray">
                <div className="logo-subhead">
                  everything your baby could want
                </div>
              </Text>
            </Box>
          </Box>
          <Box flex="grow" paddingX={2} />
          <Box paddingX={2}>
            <IconButton
              accessibilityLabel="Subscribe"
              bgColor="lightGray"
              iconColor="red"
              icon="envelope"
              size="md"
              onClick={this.handleToggleSmall}
            />
          </Box>
        </Box>
        <Banner
          products={bannerLinks1}
          imageUrl="./assets/images/IMG_0696.jpg"
        />
        <div {...css(styles.container)}>
          <Box
            display="flex"
            direction="row"
            wrap
            paddingY={2}
            marginBottom={7}
          >
            <Column span={12} mdSpan={5}>
              <Box>
                <Mask shape="rounded">
                  <img
                    alt=""
                    src="./assets/images/IMG_0277.jpg"
                    style={{ maxWidth: "100%", display: "block" }}
                  />
                </Mask>
              </Box>
              <Box paddingY={2}>
                <Text size="sm" color="gray" marginBottom={3}>
                  <Link
                    inline={true}
                    href="http://instagram.com/codysharptooth"
                    target="blank"
                  >
                    Codysharptooth
                  </Link>
                  , our doggy rep.
                </Text>
              </Box>
            </Column>
            <Column span={12} mdSpan={7}>
              <div className="serif">
                <p>
                  Hi, we're a new family living in Los Angeles with a newborn
                  baby. My wife did <b>ALOT</b> of research and I can vouch for
                  her that she has great taste! Her purchases have good value,
                  goes well with a modern decor, and is safe, well built, and
                  our daughter loves it all.
                </p>
                <p>
                  The original idea came to me when a coworker, who was pregnant
                  asked to see my wife's registry because she had no idea what
                  half of all the stuff she would need to buy. My wife had
                  gotten it all covered, so why not share this valuable
                  information with the rest of the world? You can also do your
                  own research by checking out the wirecutter who have expert
                  reviewers, or youtube for really indepth suggestions. Think of
                  this website as a <b>cheatsheet</b> for all those things
                  you'll need.
                  <Icon
                    icon="heart"
                    accessibilityLabel="Shopping Bag"
                    color="red"
                    inline={true}
                    size={20}
                  />
                </p>
                <p>
                  We have bought everything on this list unless I've specified.
                  If there's something missing, please let me know!
                </p>
                <Box
                  alignItems="center"
                  direction="row"
                  display="flex"
                  marginTop={4}
                  marginStart={-1}
                  marginEnd={-1}
                >
                  <Box paddingX={1}>
                    <Avatar
                      size="md"
                      src="../assets/images/danau.jpg"
                      name="Dan"
                      verified
                    />
                  </Box>
                  <Box paddingX={1}>
                    <Text bold>Dan Au</Text>
                    <Text>Shop My Mom</Text>
                  </Box>
                </Box>
              </div>
            </Column>
          </Box>
          <Divider />
          <Box marginTop={6}>
            <Heading size="xs" color="red">
              Shopping Guide
            </Heading>
            <Box marginBottom={1}>
              <Heading size="sm">0 - 4 months</Heading>
            </Box>
            <Box maxWidth={420} paddingY={0} marginBottom={1}>
              <Text>
                You have a newborn on the way. We spent hours pouring over
                review sites, blogs, youtube mom channels, and ended up with the
                following below:
              </Text>
            </Box>
            <Sticky top={0}>
              <CategoryFilter
                products={firstThreeMonths}
                onChange={this._handleCategoryFilterClick.bind(this)}
                activeCategory={activeCategory}
              />
            </Sticky>
            <Box display="flex" direction="row" wrap paddingY={2}>
              {firstThreeMonths.map((item, index) => {
                if (
                  item.category.indexOf(activeCategory) < 0 &&
                  activeCategory !== "all"
                ) {
                  return null;
                }
                if (index === 7) {
                  return (
                    <React.Fragment key={index}>
                      <Column span={12} mdSpan={6}>
                        <Product
                          name={item.name}
                          price={item.price}
                          url={item.url}
                          imageUrl={item.imageUrl}
                          description={item.description}
                        />
                      </Column>
                      <Banner
                        products={bannerLinks2}
                        imageUrl="./assets/images/IMG_0700.jpg"
                        spacing={true}
                      />
                    </React.Fragment>
                  );
                }
                if (index === 15) {
                  return (
                    <React.Fragment key={index}>
                      <Column span={12} mdSpan={6}>
                        <Product
                          name={item.name}
                          price={item.price}
                          url={item.url}
                          imageUrl={item.imageUrl}
                          description={item.description}
                        />
                      </Column>
                      <Banner
                        products={bannerLinks3}
                        imageUrl="./assets/images/IMG_0702.jpg"
                        spacing={true}
                      />
                    </React.Fragment>
                  );
                }
                if (index === 21) {
                  return (
                    <React.Fragment key={index}>
                      <Column span={12} mdSpan={6}>
                        <Product
                          name={item.name}
                          price={item.price}
                          url={item.url}
                          imageUrl={item.imageUrl}
                          description={item.description}
                        />
                      </Column>
                      <Banner
                        products={bannerLinks4}
                        imageUrl="./assets/images/IMG_0703.jpg"
                        spacing={true}
                      />
                    </React.Fragment>
                  );
                }
                if (index === 25) {
                  return (
                    <React.Fragment key={index}>
                      <Column span={12} mdSpan={6}>
                        <Product
                          name={item.name}
                          price={item.price}
                          url={item.url}
                          imageUrl={item.imageUrl}
                          description={item.description}
                        />
                      </Column>
                      <Banner
                        products={bannerLinks5}
                        imageUrl="./assets/images/IMG_0711.jpg"
                        spacing={true}
                      />
                    </React.Fragment>
                  );
                }
                if (index === 33) {
                  return (
                    <React.Fragment key={index}>
                      <Column span={12} mdSpan={6}>
                        <Product
                          name={item.name}
                          price={item.price}
                          url={item.url}
                          imageUrl={item.imageUrl}
                          description={item.description}
                        />
                      </Column>
                      <Banner
                        products={bannerLinks6}
                        imageUrl="./assets/images/IMG_0704.jpg"
                        spacing={true}
                      />
                    </React.Fragment>
                  );
                }
                return (
                  <Column span={12} mdSpan={6} key={index}>
                    <Product
                      name={item.name}
                      price={item.price}
                      url={item.url}
                      imageUrl={item.imageUrl}
                      description={item.description}
                    />
                  </Column>
                );
              })}
            </Box>
          </Box>
        </div>
        <div className="footer">
          <Box
            paddingY={12}
            display="flex"
            justifyContent="center"
            alignItems="center"
            direction="column"
          >
            <Box paddingX={4} paddingY={2}>
              <p className="footer__cta">Sign Up</p>
              <img
                className="logo"
                src="./assets/images/shopmymom-full-logo.png"
                alt=""
              />
            </Box>
            <MailchimpSubscribe
              url={url}
              render={({ subscribe, status, message }) => (
                <CustomForm
                  status={status}
                  message={message}
                  onValidated={formData => subscribe(formData)}
                />
              )}
            />
          </Box>
          <div className="footer__bottom">
            <Text align="center">
              made in los angeles with{" "}
              <EmojiClicker
                emoji={this.state.emoji}
                randomEmoji={this.randomEmoji}
              />{" "}
              <a className="dausign" href="http://dausign.com">
                dausign
              </a>
            </Text>
          </div>
        </div>
        {sm && (
          <Modal
            accessibilityCloseLabel="close"
            accessibilityModalLabel="Subscribe to Shop My Mom"
            heading={
              <img
                className="logo"
                src="./assets/images/shopmymom-full-logo.png"
                alt=""
              />
            }
            onDismiss={this.handleToggleSmall}
            size="sm"
            footer={
              <Box>
                <Box
                  padding={2}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  direction="column"
                >
                  <Box paddingX={4} paddingY={2}>
                    <Text>
                      We’ve spent a good amount of time finding the best
                      products for our child. Subscribe to get updates, tips,
                      tricks, and hacks for your baby, and more.
                    </Text>
                  </Box>
                  <MailchimpSubscribe
                    url={url}
                    render={({ subscribe, status, message }) => (
                      <CustomForm
                        status={status}
                        message={message}
                        onValidated={formData => subscribe(formData)}
                      />
                    )}
                  />
                </Box>
              </Box>
            }
          />
        )}
      </Box>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js